<template>
  <div class="modal fade show"
       id="staticBackdrop"
       tabindex="-1"
       aria-labelledby="exampleModalLabel"
       aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);"
       @keyup.enter="inputEnterKey"
       @keyup.esc="inputEnterKey"
       @keyup.space="inputEnterKey"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ regions.button.notification }}</h5>
          <button type="button" class="btn-close" @click="$emit('close-modal')"></button>
        </div>
        <div class="modal-body" v-if="message !== ''">
          <div>{{ isRefreshingMessage === null ? message : isRefreshingMessage }}</div>
        </div>
        <div class="modal-footer" v-if="isOutdated">
          <div class="alert alert-warning modal-outdated">
            <div class="modal-outdated_info">
              시스템 정보가 변경되어 새로 고침이 필요합니다.
            </div>
            <div>
              <button
                  type="button"
                  class="btn btn-primary modal-outdated_btn"
                  @click="forceRefreshBrowser"
                  :disabled="isRefreshingMessage !== null"
              >
                확인
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="!isOutdated">
          <button type="button" class="btn btn-primary message-box_btn" @click="$emit('close-modal', false)">{{
              regions.button.ok
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref} from 'vue';
import {useStore} from 'vuex';
import {isTachowOutdated} from "@/components/version-checker/version-checker-utils";

const props = defineProps({
  message: String
})
const emit = defineEmits(['close-modal'])

const store = useStore(),
    regions = store.state.region['regions'];

const inputEnterKey = () => {
  emit('close-modal', false)
}

const isOutdated = ref(false);
const isRefreshingMessage = ref(null);

function forceRefreshBrowser() {
  isRefreshingMessage.value = props.message;
  window.location.reload(true);
}

onMounted(async () => {
  document.getElementById("staticBackdrop").focus();
  isOutdated.value = await isTachowOutdated(store);
})

</script>

<style scoped>
.message-box_btn {
  color: white;
  text-wrap: nowrap;
}

.modal-outdated_btn {
  color: white;
  text-wrap: nowrap;
}

.modal-outdated {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.modal-outdated_info {
  flex: 1;

}
</style>
